<template>
  <div style="background-color: #F8F9FB;text-align: center;">
    <hhead></hhead>
    <div class="newsBox">
      <div class="newsList" :style="{ minHeight: MHeight }">
        <h3>全部消息</h3>
        <div class="newsLi" v-for="(item, index) in list" :key="index">
          <div
            class="imgBox"
            style="background-color: #FF9E5D;"
            v-if="item.msgType == 3"
          >
            <span class="iconfont icon-tuandui"></span>
          </div>

          <div
            class="imgBox"
            style="background-color: #FFC74F;"
            v-if="item.msgType == 2"
          >
            <span class="iconfont icon-xiaoxi"></span>
          </div>

          <div
            class="imgBox"
            style="background-color: #FFC74F;"
            v-if="item.msgType == 4"
          >
            <span class="iconfont icon-xiaoxi"></span>
          </div>

          <div
            class="imgBox"
            style="background-color: #54BDF9;"
            v-if="item.msgType == 1"
          >
            <span class="iconfont icon-zhanghao"></span>
          </div>

          <div
            class="imgBox"
            style="background-color: #FF685C;"
            v-if="item.msgType == 0"
          >
            <span class="iconfont icon-shenhe"></span>
          </div>

          <div class="right">
            <div>
              <h4
                :style="{
                  color: item.msgState == 1 ? '#868E99' : '#0A101E',
                  fontSize: '18px',
                  margin: '5px 0 15px 0',
                }"
              >
                {{ item.title }}
              </h4>
              <p
                :style="{
                  fontSize: '14px',
                  color: item.msgState == 1 ? '#868E99' : '#0A101E',
                  wordBreak: 'break-all',
                }"
              >
                {{ item.content }}
              </p>
            </div>
            <div style="width:129px">
              <p
                style="font-size: 12px;color: #868E99;margin: 8px 0 20px 0;text-align: right;"
              >
                {{ item.msgTime }}
              </p>
              <div
                style="display: flex;"
                v-if="!item.msgType && item.checkState == 0"
              >
                <span
                  @click="agree(item.checkState, item.tempId, 2, item.id)"
                  style="width: 60px;height: 24px;line-height: 24px;text-align: center;box-sizing: border-box;border: 1px solid #5B85FF;color: #5B85FF;margin-right: 9px;font-size: 14px;cursor: pointer;"
                  >拒绝</span
                >
                <span
                  @click="agree(item.checkState, item.tempId, 1, item.id)"
                  style="width: 60px;height: 24px;line-height: 24px;text-align: center;background-color: #5B85FF;color: #fff;font-size: 14px;cursor: pointer;"
                  >同意</span
                >
              </div>
              <div
                v-if="item.checkState == 1"
                style="width: 60px;height: 24px;line-height: 24px;text-align: center;color: #5B85FF;font-size: 14px;margin-left: 68px;"
              >
                已通过
              </div>
              <div
                v-if="item.checkState == 2"
                style="width: 60px;height: 24px;line-height: 24px;text-align: center;color: #F43131;font-size: 14px;margin-left: 68px;"
              >
                已拒绝
              </div>
              <div
                style="width: 60px;height: 24px;line-height: 24px;text-align: center;background-color: #5B85FF;color: #fff;font-size: 14px;cursor: pointer;margin-left: 68px;"
                v-if="item.msgType == 3"
                @click="pushTeam(item.checkState)"
              >
                审批
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="page_box">
          <div class="msg_count"></div>
          <div class="blank"></div>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pageLength"
              @current-change="currentPage"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import hhead from '../header/index';
import './style.css';
export default {
  components: { hhead },
  data() {
    return {
      MHeight: document.documentElement.clientHeight - 94 + 'px',
      list: [],
      page: 1,
      pageLength: null, //分页长度
      ids: '', //已读消息ID
    };
  },
  mounted() {
    this.pageAxios();
    this.$axios
      .post('/crm/queryMessage', {
        apiToken: this.$store.state.usermsg.apiToken,
        size: 10000,
      })
      .then((res) => {
        // console.log(res);
        this.tokenInvalid(res);
        if (res.data.code == 200) {
          this.pageLength = Math.ceil(res.data.data.length);
        }
      });
  },
  methods: {
    currentPage(e) {
      //当前页
      this.page = e;
      this.pageAxios();
    },
    pushTeam(checkState) {
      if (checkState == 0) {
        this.$router.push('/crm/team?active=2');
      } else {
        this.$alert('已处理', {
          confirmButtonText: '确定',
          type: 'warning',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      }
    },
    agree(checkState, id, state, msgid) {
      //审批通过
      //   let e = JSON.parse(dataJson);

      if (checkState == 1) {
        this.$alert('已通过', {
          confirmButtonText: '确定',
          type: 'success',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      } else if (checkState == 2) {
        this.$alert('已拒绝', {
          confirmButtonText: '确定',
          type: 'error',
          center: true,
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.$axios
          .post('/crm/agreeInvite', {
            apiToken: this.$store.state.usermsg.apiToken,
            state: state,
            invIdC: id,
            messageId: msgid,
          })
          .then((res) => {
            // console.log(res);
            if (res.data.code == 200) {
              this.pageAxios();
              this.$alert('操作成功', {
                confirmButtonText: '确定',
                type: 'success',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            } else {
              this.$alert(res.data.message, {
                confirmButtonText: '确定',
                type: 'error',
                center: true,
              })
                .then(() => {})
                .catch(() => {});
            }
          });
      }
    },

    pageAxios() {
      this.$axios
        .post('/crm/queryMessage', {
          apiToken: this.$store.state.usermsg.apiToken,
          size: 10,
          page_no: this.page,
        })
        .then((res) => {
          // console.log(res);
          this.tokenInvalid(res);
          if (res.data.code == 200) {
            this.list = res.data.data;
            let id = '';
            this.list.forEach((item) => {
              id += ',' + item.id;
            });
            this.ids = id.replace(',', '');
            this.$axios
              .post('/crm/consumeMessage', {
                ids: this.ids,
                apiToken: this.$store.state.usermsg.apiToken,
              })
              .then((result) => {
                // console.log(result);
              })
              .catch((error) => {
                // console.log(error);
              });
          } else {
            // this.$alert(res.data.message, {
            //   confirmButtonText: '确定',
            //   type: 'warning',
            //   center: true,
            // })
            //   .then(() => {})
            //   .catch(() => {});
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/crm/news/index.vue